import React, { useState } from 'react';
import { EaseModal } from '../../libs/EaseModal';
import { Text1 } from '../../styles';
import { VirtualAccountSettingsForm } from '../Common/Forms/VirtualAccountSettings';

const VirtualAccountSettingsModal = (props) => {
    const renderTitle = () => {
        return (
            <div className="mb-4">
                <Text1 className="d-block" strong>Payout Account Settings</Text1>
            </div>
        )
    };

    return (
        <EaseModal
            title={false}
            width={350}
            visible={props.visible}
            onCancel={props.toggleVirtualAccountSettingsModal}
            centered
            hideFooter
            destroyOnClose
        >
            <div>
                {renderTitle()}
                <VirtualAccountSettingsForm
                    virtualAccount={props.virtualAccount}
                    onSuccess={props.onSuccess}
                />
            </div>
        </EaseModal>
    )
}

export { VirtualAccountSettingsModal };